import { LuIcon, Menu, type MenuSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { AssetType, Stored } from "@overmap-ai/common"
import { useNavigate } from "@tanstack/react-router"
import { forwardRef, memo, useCallback } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { AssetTypeIcon } from "../Icons/AssetTypeIcon"
import { SelectItemTemplate } from "../MenuGroups/constants"

export type AssetTypeSelectGroupProps = MenuSelectGroupProps<Stored<AssetType>> & {
	/** this prop can be used if a subset of asset types need to be selected from, if not specified, all asset types will
	 * be allowed to be selected from. */
	assetTypes: Stored<AssetType>[]
	showAddAssetType?: boolean
}

export const AssetTypeSelectGroup = memo(
	forwardRef<HTMLDivElement, AssetTypeSelectGroupProps>((props, ref) => {
		const { assetTypes, showAddAssetType } = props
		const navigate = useNavigate()

		const handleAddAssetType = useCallback(() => {
			void navigate({
				from: "/$organizationId/$projectId",
				to: `/$organizationId/settings/asset-types/create`,
			})
		}, [navigate])

		return (
			<>
				<Menu.SelectGroup<Stored<AssetType>> ref={ref} {...props}>
					{assetTypes.map((assetType) => {
						return (
							<SelectItemTemplate<Stored<AssetType>> key={assetType.uuid} value={assetType}>
								<AssetTypeIcon assetTypeId={assetType.uuid} inline />
								<Text className="truncate">{assetType.name}</Text>
							</SelectItemTemplate>
						)
					})}
				</Menu.SelectGroup>
				{showAddAssetType && (
					<>
						<Menu.Separator />
						<Menu.Item onSelect={handleAddAssetType}>
							<LuIcon icon={modelIconMapping.add} />
							Add asset type
						</Menu.Item>
					</>
				)}
			</>
		)
	}),
)
